"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserHeaderActions;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserHeaderActions() {
  return _react2.default.createElement(
    "div",
    { className: "cp-user-header-actions" },
    "TODO"
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header-actions/components/UserHeaderActions.component.js
// module id = 1551
// module chunks = 1